import { Switch, Route, useRouteMatch } from "react-router-dom"
import { PlanProcedimientoAdminPage } from './admin/PlanProcedimientoAdminPage';
import { PlanProcedimientoDetailPage } from './detail/PlanProcedimientoDetailPage';

const PlanProcedimientoRoute = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/plan-procedimiento-admin`} component={PlanProcedimientoAdminPage} /> 
      <Route path={`${path}/plan-procedimiento`} component={PlanProcedimientoDetailPage} />
      <Route path={`${path}/plan-procedimiento/:id`} component={PlanProcedimientoDetailPage} /> 
    </Switch>
  )
}
export default PlanProcedimientoRoute;
